import { cn } from "@/utils/cn";
import React from "react";
import { Button } from "../button";

interface ConfirmButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isConfirming?: boolean;
  confirmText?: string;
  label: string;
  variant?: "dark" | "accent" | "outline" | "ghost";
}

export function ConfirmButton({
  isConfirming = false,
  confirmText,
  label,
  className,
  disabled,
  variant = "accent",
  ...props
}: ConfirmButtonProps) {
  return (
    <Button
      variant={variant}
      disabled={disabled || isConfirming}
      className={cn(
        "grid place-items-center [grid-template-areas:'stack'] disabled:opacity-70",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "invisible h-6 [grid-area:stack]",
          isConfirming && "visible",
        )}
      >
        {confirmText ?? " Confirming..."}
      </div>

      <span
        className={cn("visible [grid-area:stack]", isConfirming && "invisible")}
      >
        {label}
      </span>
    </Button>
  );
}
